"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class Doge extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        // https://github.com/dogecoin/dogecoin/blob/master/doc/fee-recommendation.md
        // set 0.01 DOGE as dustThreshold
        this.network.dustThreshold = 1000000;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
}
exports.default = Doge;
//# sourceMappingURL=doge.js.map